import Carroussel from "./Carroussel";

function ClientesThopen() {
  return (
    <div className="bg-gray-50 py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h3 className="text-lg font-semibold text-gray-600 mb-4">
            Clientes Thopen
          </h3>
        </div>
      </div>

      <div className="relative">
        <Carroussel />
      </div>
    </div>
  );
}

export default ClientesThopen;
